import { render, staticRenderFns } from "./EditOrderType.vue?vue&type=template&id=ecbdb1d4&scoped=true&"
import script from "./EditOrderType.vue?vue&type=script&lang=js&"
export * from "./EditOrderType.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderType.vue?vue&type=style&index=0&id=ecbdb1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbdb1d4",
  null
  
)

export default component.exports